import React from 'react'
import { Button } from '@mui/material'
import { useSearchParams, useNavigate } from "react-router-dom";



export default function FilterButton(props) {

    const navigate = useNavigate()

    const [, setSearch] = useSearchParams()

    function filter(){

        var searchParams = {}

        if (props.breed){
            searchParams.breed_id = props.breed
        }

        if (props.gender){
            searchParams.gender = props.gender
        }

        if (props.age && !(props.age[0] === 0 && props.age[1] === 20)){
            searchParams.age = props.age.toString()
        }

        if (props.mixture != null){
            searchParams.mixture = props.mixture
        }

        setSearch(searchParams)
        if (props.redirectToSearchPage){
            navigate('/Suche?'+convertToQueryString(searchParams))
        }
    }


    function convertToQueryString(params) {
        const queryString = Object.keys(params)
          .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
          .join('&');
        return queryString;
      }
      


    return (
        <Button 
        sx={{maxWidth: '100%', maxHeight: '100%', minWidth: '100%', minHeight: '100%', height: '200%'}}
        variant='contained' 
        color='primary' 
        size='large' 
        fullWidth={true} 
        onClick={filter}
        disabled={false?true:false}>
            Filtern
        </Button>
    )
}


